import React, { useState } from 'react';
import { getDeviceReturnPerson, getDeviceReturnPersonTEST } from "API";
import { useQuery } from 'react-query';
import SuspenseComponent from '../../../views/components/SuspenseComponent';
import ReactTable from "components/ReactTable/ReactTableConfig.js";
import moment from 'moment';

import {
    Card,
    CardBody,
    CardTitle,
    Row,
    Col,
    CardHeader,
} from "reactstrap";
const ReturnPersonTable = ({ valueDateRange, loading }) => {
    const [data, setData] = useState([]);
    const dataReturnPerson = useQuery('ReturnPersonData', () => getDeviceReturnPerson( valueDateRange[0], valueDateRange[1]), {
        refetchOnWindowFocus: false,
        onSuccess: (data) => {
            setData(
                data.data.recipe_number_list?.map((prop, key) => {
                    return {
                        id: prop.id,
                        recipe_number: prop.recipe_number,
                        returned: prop.returned === true ? "Yes" : "No",
                        date: moment.utc(prop.date).local().format("YYYY-MM-DD HH:mm:ss"),
                        actions: (
                            // we've added some custom button actions
                            <div className="actions-right">

                            </div>
                        )
                    };
                })
            );
        }
    });

    const dataReturnPersonTEST = useQuery('ReturnPersonDataTEST', () => getDeviceReturnPersonTEST(valueDateRange[0], valueDateRange[1]), {
        refetchOnWindowFocus: false,
        onSuccess: (data) => {
        }
    });

    const getTrProps = (rowInfo) => {
        return {
            style: {
                background: 'green',
                color: 'white'
            }
        }
    }

    return (
        <Row>
            <Col xs={12} md={12}>
                <Card>
                    <CardHeader>
                        <CardTitle tag="h4">Return Person Data</CardTitle>
                    </CardHeader>
                    <CardBody>

                        {
                            loading || dataReturnPerson.isLoading || dataReturnPerson.isFetching ? <SuspenseComponent /> :
                                <div className='return-person-table'>

                                    <ReactTable
                                        data={data}
                                        filterable
                                        resizable={false}
                                        columns={[
                                            {
                                                Header: "Date",
                                                accessor: "date",
                                                sortable: true,
                                                sortMethod: (a, b) => {
                                                    const dateA = new Date(a);
                                                    const dateB = new Date(b);
                                                    if (dateA > dateB) return -1;
                                                    if (dateA < dateB) return 1;
                                                    return 0;
                                                  },
                                            },
                                            {
                                                Header: "Recipe Number",
                                                accessor: "recipe_number"
                                            },{
                                                Header: "Returned",
                                                accessor: "returned"
                                            },
                                            {
                                                Header: "",
                                                accessor: "actions",
                                                sortable: false,
                                                filterable: false
                                            }

                                        ]}
                                        defaultPheartbeatSize={10}
                                        showPaginationTop
                                        showPaginationBottom={false}
                                        getTrProps={getTrProps}
                                        className="-striped -highlight"
                                    />
                                </div>
                        }


                    </CardBody>
                </Card>
            </Col>
        </Row>
    )
}

export default ReturnPersonTable;